import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appFocusNextInput]',
    standalone: false
})
export class FocusNextInputDirective {
  @Input() inputId: string;
  constructor() {}

  @HostListener('keydown.enter', ['$event']) onEnterKeydown(e) {
    if (this.inputId !== null && this.inputId !== undefined) {
      const inputId = this.inputId.split('_');
      const nextCellNumber = inputId[0] + '_' + (+inputId[1] + 1);
      const nextCell = document.getElementById(nextCellNumber);
      if (nextCell) {
        nextCell.focus();
        const inputElement = nextCell as HTMLInputElement;
        if (inputElement) {
          inputElement.select();
        }
      }
    }
  }
}
